import { configureStore } from '@reduxjs/toolkit'
import authReducer from "../reducers/authReducerSlice";

export const store = configureStore({
    reducer: {
        auth: authReducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false, }),
});